<template>
  <!-- Vertically Centered -->
  <b-modal
      v-model="showModal"
      hide-footer
      dialog-class="modal-dialog-centered"
      class="v-modal-custom"
      body-class="p-0"
      header-class="p-0"
      hide-header-close
  >
    <div class="modal-body">
      <div class="image-wrapper">
        <!--  显示图片      -->
        <b-img v-if="currentItem && currentItem.type == 'image'" :src="currentItem.url" fluid />
        <!--  非图片文件显示文件名和图标，点击下载文件      -->
        <b-link v-else @click.prevent="downloadFile(currentItem.url, currentItem.content_type)" class="d-flex" style="font-size: 1rem;">
          <i class="ri-file-text-line text-info me-2"></i>
          <span>{{ currentItem.filename }}</span>
        </b-link>
        <div v-if="currentItem.content" class="mt-3 text-muted text-wrap text-break">{{ currentItem.content }}</div>

        <!--   切换按钮     -->
        <div class="d-flex justify-content-between mt-2">
          <i class="ri-arrow-left-s-line prev cursor-pointer text-white" @click="previousImage"></i>
          <i class="ri-arrow-right-s-line next cursor-pointer text-white" @click="nextImage"></i>
        </div>
      </div>
    </div>
  </b-modal>


</template>

<script>
import {downloadFile} from "@/service";
export default {
  props: {
    images: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      showModal: false,
      currentImageIndex: 0,
    };
  },
  computed: {
    currentItem() {
      if (!this.images.length) {
        return {}
      }
      const item = this.images[this.currentImageIndex]
      const filename = item.object_name.split('/').pop()
      item['filename'] = filename
      if (item.content_type.startsWith('image')) {
        item['type'] = 'image'
      } else {
        item['type'] = 'file'
      }
      return item;
    },
    isFirstImage() {
      return this.currentImageIndex === 0;
    },
    isLastImage() {
      return this.currentImageIndex === this.images.length - 1;
    },
  },
  methods: {
    downloadFile,
    show(currentIndex) {
      this.currentImageIndex = currentIndex
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    nextImage() {
      if (!this.isLastImage) {
        this.currentImageIndex++;
      } else {
        this.currentImageIndex = 0;
      }
    },
    previousImage() {
      if (!this.isFirstImage) {
        this.currentImageIndex--;
      } else {
        this.currentImageIndex = this.images.length - 1;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.image-wrapper {
  position: relative;
}
.prev, .next {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  font-size: 3rem;
  :hover {
    color: #0ab39c;
  }
}
.prev {
  left: 10px;
}
.next {
  right: 10px;
}
</style>
